<div class="main_content">
    <app-breadcrumb></app-breadcrumb>
    <div class="page_main_sec">
        <div class="table_card_sec">
            <div class="title-wrap">
                <div>
                    <p class="title">User Name:&nbsp;&nbsp;&nbsp;&nbsp;<span
                            class="UserName">{{userInfo.USER_NAME}}({{userInfo.DISPLAY_NAME}})</span>
                    </p>
                </div>

                <div>
                    <button type="button"
                        class="btn primary_btn w120 me-2 waves-effect waves-light searchbtn smallButton"
                        (click)="back()">Back</button>
                </div>
            </div>
        </div>

        <!-- <div class="form-container"> -->
        <div>
            <!-- <div class="col-md-12"> -->
            <app-basic-gridview *ngIf="advanceSearchGridData.length > 0" [lstData]="advanceSearchGridData"
                [columnsToHide]="columnToHide" [gridTitle]="'User Access List'" [showExcelDownloadOption]="true"
                [showSearchOption]="true" [showRecordsPerPageOption]="true" [showPagination]="true"
                (cellClickEvent)="User_Details_grid_CellClick($event)" [exportToExcelFileName]="'Open-Search-Result'">
            </app-basic-gridview>
            <!-- </div> -->
        </div>
        <!-- Basic Grid for filtered Data to display Start -->
        <!-- </div> -->

        <div class="table_card_sec">
            <div class="table_pagination_sec ng-star-inserted">
                <h4 class="process_table_title ng-star-inserted">
                    User Access Add/Update</h4>
            </div>
            <div class="form-container">
                <div class="row form-control-sec">
                    <div class="col-md-12">
                        <div [formGroup]="frmuser">
                            <div class="row">
                                <div class="content_form_sec">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <mat-form-field appearance="legacy" [style.width.%]="100">
                                                <mat-label for="project">PROJECT</mat-label>
                                                <mat-select [formControlName]="'PROJECT_ID'"
                                                    (selectionChange)="get_group_mapping_detail();" id="project" [attr.role]="null">
                                                    <mat-option [value]="option.project_id"
                                                        *ngFor="let option of lstProject">
                                                        {{option.project_name}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <!-- <div class="col-lg-3" *ngIf="isDisplaySubgroup">
                                            <app-dropdown-multiselect #ddlSubgroupselect
                                                [lstDropdownOption]="SubgroupList" [labelText]="'SUBGROUP'"
                                                [allSelected]="true">
                                            </app-dropdown-multiselect>
                                            </div> -->
                                        
                                        <div class="col-lg-3">
                                            <app-dropdown-multiselect #ddlRoleselect [lstDropdownOption]="RoleList"
                                                [labelText]="'ROLE'" [allSelected]="true">
                                            </app-dropdown-multiselect>
                                        </div>
                                        <div class="col-lg-3">
                                            <mat-checkbox [formControlName]="'IS_DEFAULT'">
                                                MAKE DEFAULT
                                            </mat-checkbox>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="action_buttons">
                                                <button type="button"
                                                    class="btn primary_btn w120 me-2 waves-effect waves-light searchbtn smallButton"
                                                    (click)="addRoles()">Add</button>
                                                <button type="button"
                                                    class="btn secondary_btn w120 me-2 waves-effect waves-light resetButton"
                                                    (click)="reset()">Reset</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </div>

</div>